import { useState } from "react";
import BaseInput from "../BaseInput";

const formatPhone = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, "").slice(0, 11);

    // Format based on length
    if (digits.length <= 2) {
        return digits;
    } else if (digits.length <= 6) {
        return `${digits.slice(0, 2)}) ${digits.slice(2)}`;
    } else if (digits.length <= 10) {
        return `${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    } else {
        return `${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }
};

const PhoneInput = ({ value, onInput, label = "Telefone", placeholder = "+55 (00) 00000-0000", variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState("+55 (");

    const handleChange = (newValue) => {
        // If user tries to delete the prefix, prevent it
        if (newValue.length < 5) {
            setLocalValue("+55 (");
            onInput("");
            return;
        }

        // Get only the digits after the prefix
        const digits = newValue.slice(5).replace(/\D/g, "").slice(0, 11);
        const formattedValue = formatPhone(digits);
        setLocalValue(`+55 (${formattedValue}`);
        onInput(digits);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
            maxLength={19}
        />
    );
};

export default PhoneInput;
